export default __webpack_public_path__ + "static/media/pagesaver.83654253.jpg";